import { apiConstants } from "./constants/apiConstants";

//form data for  add consultation
export const locationSelectorForm = {
  [apiConstants.location]: "",
  [apiConstants.calander]: "",
  [apiConstants.time]: "",
  [apiConstants.mobile_number]: "",
  [apiConstants.timezone]: "",
  [apiConstants.country_code]: "",
  [apiConstants.first_name]: "",
  [apiConstants.last_name]: "",
  [apiConstants.email]: "",
  [apiConstants.terms_check]: false,
  [apiConstants.email_reminders_opt_in]: false,
};
